<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-card>
				<v-card-title primary-title>
					{{ $t("title.create_address") }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ShopFormAddress v-model="item"></ShopFormAddress>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click.native="submit()"
						:loading="item.processing"
						:disabled="invalid"
					>
						<v-icon left>mdi-content-save</v-icon>
						{{ $t("Save") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</ValidationObserver>
	</v-container>
</template>

<script>
import ShopFormAddress from "@Shop/forms/ShopFormAddress.vue";
export default {
	components: {
		ShopFormAddress,
	},
	data() {
		return {
			item: this.$inertia.form({
				name: "home",
				house_number: null,
				street: null,
				address: null,
				phone_number: this.$page.props.auth.customer.phone,
				contact_person: this.$page.props.auth.customer.display_name,
				description: null,
				latitude: 11.562454466918203,
				longitude: 104.92219185180667,
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("shop.addresses.store"));
		},
	},
	mounted() {
		this.$getLocation({
			enableHighAccuracy: true,
		}).then((coordinates) => {
			this.item.latitude = coordinates.lat;
			this.item.longitude = coordinates.lng;
		});
	},
};
</script>